export const getUserGroups = (state) => state.userGroups.data;

export const isUserGroupsLoading = (state) => state.userGroups.loading;
